import {html} from 'lit';
import {OutlineElement} from '../../base/outline-element/outline-element.ts';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';

import stylesParagraph from '../paragraph/paragraph.css.lit.ts';
import stylesLink from '../link/link.css.lit.ts';
import stylesButton from '../button/button.css.lit.ts';
import stylesList from '../list/list.css.lit.ts';
import stylesHeading from '../heading/heading.css.lit.ts';
import stylesBlockquote from '../blockquote/blockquote.css.lit.ts';
import stylesTable from '../table/table.css.lit.ts';
import stylesImage from '../image/image.css.lit.ts';
import stylesWysiwyg from './wysiwyg.css.lit.ts';
import {leavingSiteAlertHandler} from "../../utils/link";

export default class WYSIWYG extends OutlineElement {
  static styles = [
    stylesParagraph,
    stylesLink,
    stylesButton,
    stylesList,
    stylesHeading,
    stylesBlockquote,
    stylesTable,
    stylesImage,
    stylesWysiwyg
  ];

  connectedCallback() {
    super.connectedCallback()

    this.shadowRoot.addEventListener('click', (event) => {
      const composedPathElement = event.composedPath().slice(0, 3)
      const isExternalLink = composedPathElement
        .filter(element => 'classList' in element && element.classList.contains('link--external'))
        .length > 0;

      if (isExternalLink && !leavingSiteAlertHandler()) {
        // event.preventDefault()
      }
    });
  }

  static get properties() {
    return {
      /**
       * HTML Markup to render
       */
      markup: { type: String },
    };
  }

  render() {
    return html`${unsafeHTML(this.markup)}`;
  }
}

customElements.define('hf-wysiwyg', WYSIWYG)
